export const TASKSTATUS_AVAILABLE = 'TASKSTATUS_AVAILABLE'
export const TASKSTATUS_INPROGRESS = 'TASKSTATUS_INPROGRESS'
export const TASKSTATUS_COMPLETED = 'TASKSTATUS_COMPLETED'
export const TASKSTATUS_CANCELED = 'TASKSTATUS_CANCELED'
